function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100px;\n  width: auto;\n  animation-duration: 3s, 1s;\n  animation-name: rotate, fadeInOut;\n  animation-iteration-count: infinite, 1;\n  opacity: 0.4;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import PropTypes from "prop-types";
import { jsx, css } from "@emotion/core";
import { isClient } from "@hackoregon/utils";
import logoC from "../../assets/civic-logo-c.svg";
var stylesClass = css(_templateObject());

var CivicLogoCAnimated = function CivicLogoCAnimated(_ref) {
  var alt = _ref.alt;
  return isClient && jsx("img", {
    css: stylesClass,
    src: logoC,
    alt: alt
  });
};

CivicLogoCAnimated.displayName = "Logo";
CivicLogoCAnimated.propTypes = {
  alt: PropTypes.string
};
export default CivicLogoCAnimated;